import type { TimePeriodId } from '@myfunnow/web-core/time-filter'

import type { FilterComponentState } from '@/types/filters'
import { FilterTypeEnum } from '@/types/filters'
import { SortRuleEnum } from '@/types/product'

export const DEFAULT_FILTER_STATE: FilterComponentState = {
  [FilterTypeEnum.SORTBY]: SortRuleEnum.POPULAR,
  [FilterTypeEnum.NOW]: 0,
  [FilterTypeEnum.DATE]: null,
  [FilterTypeEnum.LIMIT]: 0,
  [FilterTypeEnum.PRICE]: [null, null],
  [FilterTypeEnum.FILTER_TIMES]: [],
  [FilterTypeEnum.DISCOUNT]: 0,
  [FilterTypeEnum.RATING]: 0,
}

export const HOME_PAGE_FILTER_LAYOUT_TYPE_LIST = [FilterTypeEnum.DATE, FilterTypeEnum.FILTER_TIMES, FilterTypeEnum.LIMIT]

/** 與 NOW filter 互斥的 filter types：提交時需清除 NOW */
export const NOW_EXCLUSIVE_FILTER_TYPES = new Set<string>([FilterTypeEnum.DATE, FilterTypeEnum.FILTER_TIMES])

export const DEFAULT_FILTER_MAX_COUNT = 100
export const DEFAULT_MAX_HEADCOUNT = 20

/** 時段分組 id 對應的 i18n key mapping */
export const TIME_PERIOD_I18N_MAP: Record<TimePeriodId, { labelI18n: string; rangeTextI18n: string }> = {
  morning: { labelI18n: 'filter.date.morning', rangeTextI18n: 'filter.date.morning_time' },
  noon: { labelI18n: 'filter.date.noon', rangeTextI18n: 'filter.date.noon_time' },
  afternoon: { labelI18n: 'filter.date.afternoon', rangeTextI18n: 'filter.date.afternoon_time' },
  night: { labelI18n: 'filter.date.night', rangeTextI18n: 'filter.date.night_time' },
  midnight: { labelI18n: 'filter.date.early_morning', rangeTextI18n: 'filter.date.early_morning_time' },
}
